import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton, PrismComboSelectInput } from '@mylighthouse/prism-ember';
import GeneralDropdownsTriggersTriggerDropdownIconButton from 'lumen/components/general/dropdowns/triggers/trigger-dropdown-icon-button';
import type { CostSettingProfile } from 'lumen/models';

export interface SettingsCostTablesCellsTdWithActionsSignature {
  Args: {
    cellData: CostSettingProfile;
    column: {
      isReadOnly?: boolean;
    };
  };
  Element: HTMLTableCellElement;
}

const ACTIONS = {
  DELETE: 'delete',
} as const;

/**
 * Row actions for a cost profile. Edit and Delete are wired up later
 * (PIN-1244 / PIN-1264); for now Edit is a disabled button and the kebab's
 * Delete option is disabled.
 */
export default class SettingsCostTablesCellsTdWithActions extends Component<SettingsCostTablesCellsTdWithActionsSignature> {
  @service declare intl: Services['intl'];

  get options(): {
    disabled: boolean;
    icon: 'bin';
    label: string;
    value: string;
  }[] {
    return [
      {
        disabled: true,
        icon: 'bin',
        label: this.intl.t('general.delete'),
        value: ACTIONS.DELETE,
      },
    ];
  }

  @action handleOnChange(): void {
    // Delete is disabled until PIN-1264, so there is nothing to handle yet.
  }

  <template>
    {{#unless @column.isReadOnly}}
      <div>
        <PrismButton
          @buttonType="ghost"
          @icon="edit-pencil"
          @isDisabled={{true}}
          @size="small"
          data-test-id="cost-profile-edit"
        />
        <PrismComboSelectInput
          @onChange={{this.handleOnChange}}
          @options={{this.options}}
          @unsafe_triggerComponent={{component
            GeneralDropdownsTriggersTriggerDropdownIconButton
            buttonType="ghost"
            icon="kebab"
            small=true
          }}
          data-test-id="cost-profile-kebab"
        />
      </div>
    {{/unless}}
  </template>
}
